import React from "react";
import { withRouter } from "react-router-dom";

import { Button } from "react-bootstrap";

import styles from "./style.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons";

export default class Models extends React.PureComponent {
  state = {};

  renderModel(model, index) {
    const { modelOptions, updateModelOptions } = this.props;

    const isIncluded = model && model.isIncluded === true;

    return (
      <div
        className={styles.model}
        style={{ opacity: isIncluded !== true ? 0.5 : 1 }}
        onClick={() => updateModelOptions(model.name, !isIncluded)}
        key={index}
      >
        <div className={styles.checkbox}>
          <input type="checkbox" checked={isIncluded === true} onChange={() => {}} />
        </div>
        <div className={styles.modelLabel}>{model.name}</div>
        <div className={styles.actions}>
          <div className={styles.icon}>
            <FontAwesomeIcon icon={faCog} />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { step, modelOptions, outcomeType, customModelURL, initRun, updateStep } = this.props;

    const isShow = true;

    return (
      <div>
        <div className={styles.models} style={{ opacity: isShow ? 1 : 0, height: isShow ? "400px" : "0px" }}>
          <div className={styles.mOptions}>
            <div className={styles.mHeader}>{"Select Models to Include"}</div>
            <div className={styles.modelOptions}>
              {modelOptions && modelOptions.map((m, index) => this.renderModel(m, index))}
            </div>
          </div>
          <div className={styles.custom}></div>
          <div className={styles.right}></div>
        </div>
      </div>
    );
  }
}
